import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

const Label = styled.label`
  display: inline-block;
  position: relative;
  cursor: pointer;
  width: ${props => props.$width}px;
  height: ${props => props.$width}px;
  min-width: ${props => props.$width}px;
  margin: ${props => props.$margin};
`;

const Input = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;

  &:hover,
  &:focus,
  &:active {
    opacity: 0;
  }
`;

const StyledCheckbox = styled.span`
  display: inline-block !important;
  position: absolute;
  top: 0px;
  left: 0px;
  width: ${props => props.$width}px;
  height: ${props => props.$width}px;
  border: 2px solid ${props => props.$borderColor};
  border-radius: ${props => props.$borderRadius};
  background-color: transparent;
  transition: all 0.3s ease-out;
  -webkit-transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -ms-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
  &:after {
    position: absolute;
    content: '';
    height: 0px;
    width: 0px;
    opacity: 0;
    transition: all 0.3s ease-out;
    -webkit-transition: all 0.3s ease-out;
    -moz-transition: all 0.3s ease-out;
    -ms-transition: all 0.3s ease-out;
    -o-transition: all 0.3s ease-out;
  }
  ${props =>
    props.checked
      ? css`
          opacity: 1;
          background-color: ${props.$tickBgColor};
          border: 2px solid ${props.$tickBgColor};
          transform: rotate(0deg) scale(1);
          -ms-transform: rotate(0deg) scale(1);
          -webkit-transform: rotate(0deg) scale(1);
          &:after {
            opacity: 1;
            left: 50%;
            top: 50%;
            width: ${props.$width * 0.3}px;
            height: ${props.$width * 0.6}px;
            background-color: transparent;
            border-radius: 0;
            border: solid ${props.$tickColor};
            border-width: 0 2px 2px 0;
            transform: rotate(45deg) scale(1) translate(-117%, -28%);
            -ms-transform: rotate(45deg) scale(1) translate(-117%, -28%);
            -webkit-transform: rotate(45deg) scale(1) translate(-117%, -28%);
          }
        `
      : null};
  ${props =>
    props.disabled
      ? css`
          opacity: 0.5;
          background-color: grey;
        `
      : null};
`;

function MCheckBox(props) {
  const {
    checked,
    onChange,
    tickColor,
    tickBgColor,
    borderColor,
    borderRadius,
    width = '21',
    margin,
    disabled,
    className = '',
  } = props;
  return (
    <Label
      $width={width}
      $margin={margin}
      className={`${className} mr-checkbox-label`}
    >
      <Input
        type="checkbox"
        onClick={onChange}
        disabled={disabled}
        data-mr-input
      />
      <StyledCheckbox
        checked={checked}
        disabled={disabled}
        $width={width}
        $borderColor={borderColor}
        $tickColor={tickColor}
        $tickBgColor={tickBgColor}
        $borderRadius={borderRadius}
        className={`mr-input-checked ${
          checked ? 'mr-input-checked--checked' : 'mr-input-checked--unchecked'
        }`}
      />
    </Label>
  );
}

MCheckBox.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  width: PropTypes.string,
  disabled: PropTypes.bool,
  borderColor: PropTypes.string,
  borderRadius: PropTypes.string,
  tickColor: PropTypes.string,
  tickBgColor: PropTypes.string,
  margin: PropTypes.string,
  className: PropTypes.string,
};

export default MCheckBox;
